import eyeSvg    from '../images/svg/eye.svg?raw'
import eyeOffSvg from '../images/svg/eye-off.svg?raw'

export default function($) {
  // --- Password toggle (show/hide) ---
  $('.login-password').each(function () {
    const $wrapper = $(this);
    const $input   = $wrapper.find('input[type="password"]');

    if (!$input.length) return;

    // Wrap the input so we can position the toggle button inside it
    $input.wrap('<div class="password-field-wrap"></div>');

    const $toggle = $('<button>', {
      type        : 'button',
      class       : 'password-toggle',
      'aria-label': 'Afficher / masquer le mot de passe',
      html        : eyeSvg,
    });

    $input.after($toggle);

    $toggle.on('click', function () {
      const isPassword = $input.attr('type') === 'password';
      $input.attr('type', isPassword ? 'text' : 'password');
      $toggle.html(isPassword ? eyeOffSvg : eyeSvg);
    });
  });

  // --- Form validation ---
  $('.form-error').attr('aria-invalid', 'true');

  const $formFields = $('input:not([type="hidden"]), select, textarea');

  $formFields.on('invalid', function() {
    $(this).attr('aria-invalid', 'true');
  });

  $formFields.on('input change', function() {
    if (this.checkValidity()) {
      $(this).removeAttr('aria-invalid');
    } else {
      $(this).attr('aria-invalid', 'true');
    }
  });
}
